module.exports = __webpack_public_path__ + "static/media/11.c746a559.jpg";